import React from 'react';
import jet from "@randajan/jet-core";

import "./SocialLinks.scss";
import { useBeam } from '@randajan/bifrost/client/react';
import { linksBeam } from '../../../assets/beams/linksBeam';
import { WebLink } from '../../../elements/WebLink/WebLink';

export const SocialLinks = (props)=>{
    const { className } = props;
    const { data:links } = useBeam(linksBeam);
    
    return (
        <div className={jet.melt(["SocialLinks", className], " ")}>
            {links?.filter(l=>l.category === "socials").map((link, key)=><WebLink key={key} link={link} short/>)}
        </div>
    )
}

